import classNames from "classnames"
import { useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useHarvestTrackingStatus } from "~/hooks/harvest"
import { getCurrentSpace } from "~/store"
import { HarvestContextMenu } from "../HarvestContextMenu/HarvestContextMenu"
import { IconHarvest } from "../Icons/IconHarvest"
import Popover from "../Popover/Popover"
import HarvestClock from "../HarvestClock/HarvestClock"
import "./HarvestTrackingButton.scss"

type HarvestTrackingButtonProps = {
  className?: string
}

export default function HarvestTrackingButton({
  className,
}: HarvestTrackingButtonProps) {
  const popoverTrigger = useRef<HTMLButtonElement>(null)
  const space = useSelector(getCurrentSpace)
  const workTimerIsRunning = Boolean(
    space?.current_timer && !space.current_timer.break,
  )
  const {
    data: trackingStatus,
    isLoading,
    refetch,
  } = useHarvestTrackingStatus()
  let clockState: "clock" | "warning" | "hidden"
  if (isLoading) {
    clockState = "hidden"
  } else if (trackingStatus?.status === "running") {
    clockState = "clock"
  } else {
    clockState = workTimerIsRunning ? "warning" : "hidden"
  }

  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div
      className={classNames("HarvestTrackingButton", className, {
        "HarvestTrackingButton--wiggle": clockState === "warning",
      })}
    >
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        ref={popoverTrigger}
        className="HarvestTrackingButton__button"
      >
        <IconHarvest className="HarvestTrackingButton__icon" />
        <HarvestClock
          state={clockState}
          className="HarvestTrackingButton__clock"
        />
      </button>

      {trackingStatus && (
        <Popover
          shown={menuOpen}
          onDismiss={() => setMenuOpen(false)}
          point="bottom"
          className={classNames("HarvestTrackingButton__menu", {
            "HarvestTrackingButton__menu--running":
              trackingStatus?.status === "running",
          })}
          triggerRef={popoverTrigger}
        >
          <HarvestContextMenu
            onUpdated={() => {
              refetch()
              setMenuOpen(false)
            }}
            isOpen={menuOpen}
            trackingStatus={trackingStatus}
          />
        </Popover>
      )}
    </div>
  )
}
